import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_SUPERVISORS_ATTEMPT,
  GET_SUPERVISORS_SUCCESS,
  GET_SUPERVISORS_FAILURE,
} from "../constants";

// getSupervisors actions
const getSupervisorsAttempt = () => ({
  type: GET_SUPERVISORS_ATTEMPT,
});

const getSupervisorsSuccess = (payload: any) => ({
  type: GET_SUPERVISORS_SUCCESS,
  payload,
});

const getSupervisorsFailure = (error: string) => ({
  type: GET_SUPERVISORS_FAILURE,
  payload: {
    error,
  },
});

export const getSupervisorsRequest = (data: any, paramsToAdd: any) => (dispatch: Dispatch) => {
  dispatch(getSupervisorsAttempt());

  const params2 = {
    entity: "supervisors",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => {
        res.data.data = res.data.data.map((x: any) => {
            return {...x, joined: `${x.supervisorId} - ${x.supervisorName}` }
        });
        return res.data;
    })
    .then((payload) => {
      dispatch(getSupervisorsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getSupervisorsFailure(error.message));
    });
};
